import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {PortalAuthService} from "portal-auth";

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(private portalAuthService: PortalAuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.portalAuthService.login();
  }
}
